var _rect, _rect2, _rect3, _line, _line2, _line3, _circle, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobdetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 10,
    fill: "#f8f9fa",
    stroke: "#dee2e6",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 35,
    width: 60,
    height: 40,
    rx: 5,
    fill: "#007bff",
    stroke: "#0056b3",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 25,
    width: 30,
    height: 15,
    rx: 3,
    fill: "#007bff",
    stroke: "#0056b3",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 45,
    x2: 50,
    y2: 45,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 55,
    x2: 70,
    y2: 55,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 65,
    x2: 60,
    y2: 65,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 30,
    r: 8,
    fill: "#ffc107"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "75,25 76.5,29 81,29 77.5,32 79,36 75,33 71,36 72.5,32 69,29 73.5,29",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobdetails);
export default __webpack_public_path__ + "static/media/jobdetails.55f1ac41c3e6cfdee72f8be7eb2a9fe8.svg";
export { ForwardRef as ReactComponent };